import { useCallback, useState } from "react";
import { useMutation, useQuery } from "react-query";


//este es un hook que se encarga de hacer las consultas a la base de datos enmascarando el uso de la libreria react-query
export const useQueryAdapter = ({ data: _data, fnquery, name, isAsync, retry = false,staleTime=Infinity,refetchInterval=(1000*60*10) }) => {
    const [data, setData] = useState(_data ?? null);
    const [isLoading, setIsLoading] = useState(false);
    const { isLoading: isLoadingLibrary, isError: isErrorLibrary, data: dataLibrary, refetch } = useQuery(`${name ?? ""}-${data ? JSON.stringify(data) : null}`,
        async () => await fnquery(data),
        {
            enabled: !!data && !isAsync,
            staleTime,
            retry,
            refetchInterval,
            refetchOnMount: "always"
        }
    );
    const asyncFetch = useCallback(async (_data = null) => {
        setIsLoading(true);
        let res = null;
        try {
            res = await fnquery(_data ?? data);
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
        return res;
    }, [data, fnquery]);

    return { refetch, isLoading: isLoadingLibrary || isLoading, isError: isErrorLibrary, data: dataLibrary, setData, asyncFetch };

}

export const useMutationAdapter = (fnquery,{...rest} = {}) => {
    const [called, setCalled] = useState(false);
    const { mutateAsync, isLoading,mutate } = useMutation(fnquery,{...rest,retry: false});
    const _mutateAsync = useCallback(async (_data = null) => {
        setCalled(true);
        let res = await mutateAsync(_data)
        return res;
    }, [mutateAsync]);

    const _mutate = useCallback(async (_data = null) => {
        setCalled(true);
        let res = await mutate(_data)
        return res;
    }, [mutate]);

    return { mutateAsync: _mutateAsync, isLoading, called,mutate:_mutate };
}